import { render, staticRenderFns } from "./K8s.vue?vue&type=template&id=2de8b2a4&scoped=true"
import script from "./K8s.vue?vue&type=script&lang=js"
export * from "./K8s.vue?vue&type=script&lang=js"
import style0 from "./K8s.vue?vue&type=style&index=0&id=2de8b2a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de8b2a4",
  null
  
)

export default component.exports